import axios from "axios";
import { API_URL } from "@/config";

const TURNOVERS_URL = `${API_URL}/inventory/inventoryTurnovers`;

const store = {
  namespaced: true,

  actions: {
    async getMany(_, { filters, type, pageNumber = 1, perPage = 20 }) {
      const query = {
        ...filters,
        type,
        page: pageNumber,
        perPage,
      };

      const response = await axios.get(TURNOVERS_URL, { params: query });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, inventoryTurnoverId) {
      const response = await axios.get(`${TURNOVERS_URL}/${inventoryTurnoverId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, inventoryTurnoverData) {
      const response = await axios.post(TURNOVERS_URL, inventoryTurnoverData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { inventoryTurnoverId, inventoryTurnoverData }) {
      const response = await axios.put(
        `${TURNOVERS_URL}/${inventoryTurnoverId}`,
        inventoryTurnoverData,
      );

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async attachmentsUpload(_, files) {
      const formData = new FormData();

      files.forEach((file) => {
        formData.append("attachments[]", file);
      });

      const response = await axios.post(`${TURNOVERS_URL}/attachments`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 201 || !Array.isArray(response.data)) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async attachmentBlob(_, { inventoryTurnoverId, attachmentId }) {
      const response = await axios({
        url: `${TURNOVERS_URL}/${inventoryTurnoverId}/attachments/${attachmentId}/download`,
        method: "GET",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async attachmentDelete(_, { inventoryTurnoverId, attachmentId }) {
      const response = await axios.delete(
        `${TURNOVERS_URL}/${inventoryTurnoverId}/attachments/${attachmentId}`,
      );

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
